











import { namespace } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { CART } from '@/store/types';
import { CommonOrderDetailService } from '@/services/order/CommonOrderDetailService';

const cart = namespace(CART);

@Component({
  components: {}
})
export default class DeliveryStepView extends Vue {
  public notes = '';

  private orderDetailService = CommonOrderDetailService.singleton();

  @Watch('notes')
  public onNotesChange() {
    this.orderDetailService.saveNotes(this.notes);
  }
}
